import React from "react";
import "./DetailTermsCondition.css";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

function DetailTermsCondition() {
  return (
    <div style={{ paddingBlock: "9rem", backgroundColor: "#FFFFFF" }}>
      <Container>
        <h2 className="header">
          <strong>Boostboard Terms and Conditions</strong>
        </h2>

        <p>
          These Terms and Conditions ("Terms") govern your use of Boostboard, a
          digital signage software product owned and operated by Nayatel Pvt.
          Ltd. ("Nayatel"). By using Boostboard, you agree to comply with these
          Terms.
        </p>

        <p>
          <strong>Proprietary Rights</strong>
        </p>

        <p>
          Boostboard is the proprietary software of Nayatel. All intellectual
          property rights, including trademarks, logos, and software code, are
          the exclusive property of Nayatel. You may not copy, modify,
          distribute, or create derivative works of Boostboard without prior
          written consent from Nayatel.
        </p>
        
        <p>
          <strong>Amendments and Changes</strong>
        </p>

        <p>
          Nayatel reserves the right to amend, modify, or discontinue any
          features, pricing plans, or aspects of Boostboard at its sole
          discretion. Such changes may be made without prior notice. You agree
          to remain bound by any updated Terms when using Boostboard after such
          changes are made.
        </p>

        <p>
          <strong>Software Only</strong>
        </p>

        <p>
          Boostboard is a software product provided by Nayatel. We do not claim
          any rights or responsibilities for any content displayed or stored on
          the software by users. Nayatel is a software company and does not hold
          any contracts, references, or claims related to hardware, third-party
          services, or user data beyond the scope of the software provided.
        </p>
        <p>
          <strong>Limitations of Liability</strong>
        </p>
        <p>
          Nayatel shall not be held liable for any direct, indirect, incidental,
          or consequential damages arising from the use or inability to use
          Boostboard. This includes, but is not limited to, content errors, loss
          of data, or unauthorized access to user content.
        </p>
        <p>
          <strong>User Responsibilities</strong>
        </p>
        <p>
          Users are solely responsible for the content displayed through
          Boostboard and ensuring that such content complies with local laws and
          regulations. Nayatel holds no responsibility for any misuse or illegal
          content uploaded or shown on Boostboard by users.
        </p>
        <p>
          <strong>Termination</strong>
        </p>
        <p>
          Nayatel reserves the right to terminate your access to Boostboard if
          these Terms are violated or if the service is discontinued. You may
          cancel your subscription at any time by contacting Nayatel customer
          support.
        </p>
        <p>
          <strong>Governing Law</strong>
        </p>
        <p>
          These Terms are governed by the laws of Pakistan. Any disputes arising
          from these Terms shall be resolved in the courts of Islamabad,
          Pakistan.
        </p>
        <p>
          <strong>Contact Information</strong>
        </p>
        <p>
        For any questions or concerns about these Terms, please contact Nayatel at  
          <Link to="mailto:support@nayatel.com"> support@nayatel.com</Link>.
        </p>
        <p>
          <strong>Taxes and Duties</strong>
        </p>
        <p>
          All prices listed for Boostboard services are exclusive of any
          applicable taxes. As a customer, you are responsible for paying any
          federal, provincial, or local taxes, duties, or other charges that may
          be levied by government authorities in relation to the purchase or use
          of the Boostboard product. These taxes will be calculated and applied
          during the billing process based on your geographical location and
          applicable tax laws.
        </p>
        <p>
          <strong>
            By using Boostboard, you acknowledge that you have read, understood,
            and agree to these Terms and Conditions.
          </strong>
        </p>
      </Container>
    </div>
  );
}

export default DetailTermsCondition;
